import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import config from "@/config";
import { DO_ROUTE } from "./config/constants/action-types";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

/* Con esto actualizo el store con el paso actual para que los watchers lo sepan */
router.beforeEach((to, from, next) => {
  to.meta.config = config.getPasoProperties(to.name);
  to.meta.name = to.name;
  store.dispatch(DO_ROUTE, to);
  next();
});

export default router;
